import { useContext } from "react";
import { TeamsAuthContext } from "../contexts/TeamsAuthProvider";

export const useTeamsAuth = () => {
  return useContext(TeamsAuthContext);
};